import {ValueObject} from '@s-ui/domain'

export class VehicleHistoryValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Boolean} data.hasReport
   * @param {String} data.reportUrl
   * @param {VehicleDataValueObject} data.verifiedData
   *
   */
}
